export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/obs_studio.607f2ff.svg";